<template>
  <div>
    <div class="grupo-imagenes">
      <div class="grupo">
        {{ titulo }}
      </div>
      <span class="cuenta-imagenes">{{ imagenes.length }}</span>
    </div>
    <p
      v-if="ayuda"
      class="ayuda"
    >
      {{ ayuda }}
    </p>

    <div class="rejilla-imagenes">
      <div
        v-for="(imagen, indice) in imagenes"
        :key="imagen.idImagen"
        class="celda-imagen"
      >
        <v-img
          :src="imagen.pathBase64"
          cover
          :aspect-ratio="1"
          class="imagen"
        />
        <span
          v-if="indice === 0"
          class="cinta-principal"
        >Principal</span>
        <v-btn
          icon
          size="x-small"
          class="btn-eliminar"
          @click="pedirConfirmacion(imagen, indice)"
        >
          <v-icon size="16">
            mdi-delete
          </v-icon>
        </v-btn>
      </div>

      <!-- Agregar es una celda mas de la rejilla, no un boton suelto arriba:
           queda junto a lo que va a modificar. -->
      <button
        type="button"
        class="celda-agregar"
        @click="$emit('agregar')"
      >
        <v-icon size="26">
          mdi-plus
        </v-icon>
        <span>Agregar</span>
      </button>
    </div>

    <!-- La confirmacion vive en este componente y no en cada vista: asi la
         galeria de la empresa y la del producto preguntan igual, y no puede
         pasar que alguien agregue una tercera y se le olvide. -->
    <v-dialog
      v-model="dialogoAbierto"
      max-width="420"
    >
      <v-card class="modal modal-confirmar">
        <div class="modal-confirmar-cabecera">
          <div class="modal-confirmar-icono">
            <v-icon size="20">
              mdi-alert-outline
            </v-icon>
          </div>
          <h2 class="modal-confirmar-titulo">
          Eliminar foto
          </h2>
        </div>

        <v-card-text class="modal-confirmar-cuerpo">
          <div class="previa">
            <v-img
              v-if="porEliminar"
              :src="porEliminar.imagen.pathBase64"
              cover
              :aspect-ratio="1"
              class="previa-img"
            />
            <div>
              <p>Se va a eliminar esta foto.</p>
              <p
                v-if="porEliminar && porEliminar.indice === 0 && imagenes.length > 1"
                class="previa-aviso"
              >
                Es la principal: la siguiente pasará a ocupar su lugar.
              </p>
              <p class="modal-irreversible">
                Esta acción no se puede deshacer.
              </p>
            </div>
          </div>
        </v-card-text>
        <v-card-actions class="modal-confirmar-pie">
          <v-spacer />
          <v-btn
            variant="text"
            @click="dialogoAbierto = false"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="red"
            variant="flat"
            @click="confirmar"
          >
            Eliminar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
/**
 * Rejilla de imagenes editable, la misma para productos y para empresas.
 *
 * Se saco a un componente en vez de copiar la plantilla y los estilos en los
 * dos sitios: eran dos galerias que hacian lo mismo y se habian ido separando
 * (una tenia el boton de borrar rojo a media foto, la otra no).
 *
 * No sabe de APIs a proposito: recibe las imagenes ya cargadas y avisa hacia
 * arriba, porque productos y empresas usan endpoints distintos.
 */
export default {
  name: 'GaleriaEditable',
  props: {
    imagenes: {
      type: Array,
      required: true
    },
    titulo: {
      type: String,
      default: 'Imágenes'
    },
    ayuda: {
      type: String,
      default: 'La primera es la que se ve en el catálogo'
    }
  },
  emits: ['agregar', 'eliminar'],
  data() {
    return {
      dialogoAbierto: false,
      // { imagen, indice }, o null si no hay ninguna en cuestion
      porEliminar: null
    }
  },
  methods: {
    pedirConfirmacion(imagen, indice) {
      this.porEliminar = { imagen, indice }
      this.dialogoAbierto = true
    },
    confirmar() {
      if (this.porEliminar) {
        this.$emit('eliminar', this.porEliminar.imagen.idImagen)
      }
      this.dialogoAbierto = false
      this.porEliminar = null
    }
  }
}
</script>

<style scoped>
.grupo-imagenes {
  display: flex;
  align-items: center;
  gap: 8px;
}
.grupo {
  font-size: 0.72rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #1976d2;
}
.cuenta-imagenes {
  min-width: 20px;
  height: 20px;
  padding: 0 6px;
  border-radius: 10px;
  background: #e8f1fb;
  color: #1976d2;
  font-size: 0.7rem;
  font-weight: 700;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.ayuda {
  margin: 6px 0 10px;
  font-size: 0.76rem;
  color: #98a2b3;
}

.rejilla-imagenes {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px;
}
@media (min-width: 700px) {
  .rejilla-imagenes {
    grid-template-columns: repeat(4, 1fr);
  }
}
@media (max-width: 420px) {
  .rejilla-imagenes {
    grid-template-columns: repeat(2, 1fr);
  }
}

.celda-imagen {
  position: relative;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #e4e7ec;
  /* Sin esto el aspect-ratio del v-img se lo come el min-height: auto */
  min-height: 0;
}
.imagen {
  width: 100%;
}
.cinta-principal {
  position: absolute;
  left: 5px;
  bottom: 5px;
  padding: 1px 7px;
  border-radius: 9px;
  background: rgba(0, 0, 0, 0.62);
  color: #fff;
  font-size: 0.62rem;
  font-weight: 600;
}
/* Discreto y en la esquina: el rojo a pantalla completa que habia antes se
   comia la foto que se supone que estas mirando */
.btn-eliminar {
  position: absolute;
  top: 5px;
  right: 5px;
  background: rgba(0, 0, 0, 0.55);
  color: #fff;
}
.btn-eliminar:hover {
  background: #b42318;
}

.celda-agregar {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  aspect-ratio: 1;
  min-height: 0;
  border: 1px dashed #c4cbd4;
  border-radius: 8px;
  background: #fafbfc;
  color: #667085;
  font-size: 0.72rem;
  font-weight: 600;
  cursor: pointer;
  transition: border-color 0.15s ease, color 0.15s ease, background 0.15s ease;
}
.celda-agregar:hover {
  border-color: #1976d2;
  background: #f2f7fd;
  color: #1976d2;
}

/* CONFIRMACION */
.previa {
  display: flex;
  gap: 12px;
  align-items: flex-start;
}
.previa-img {
  flex: 0 0 auto;
  width: 76px;
  border-radius: 8px;
  border: 1px solid #e4e7ec;
}
.previa-aviso {
  margin: 6px 0 0;
  font-size: 0.82rem;
  color: #b26a00;
}
</style>
